import React from 'react';

const Speedometer = ({ value, warning, target, max, label }) => {
    const clampedValue = Math.min(Math.max(value, 0), max);
    let textColor = '#ef4444'; 
    if (clampedValue >= target) textColor = '#10b981'; 
    else if (clampedValue >= warning) textColor = '#f59e0b'; 

    let rotation = -90;
    if (warning === 0 && target === 0 && max === 0) {
         rotation = -90; 
    } else if (clampedValue < warning) {
        const zoneRange = warning;
        const zoneProgress = zoneRange === 0 ? 0 : clampedValue / zoneRange;
        rotation = -90 + (zoneProgress * 60);
    } else if (clampedValue < target) {
        const zoneRange = target - warning;
        const zoneProgress = zoneRange === 0 ? 0 : (clampedValue - warning) / zoneRange;
        rotation = -30 + (zoneProgress * 60);
    } else {
        const zoneRange = max - target;
        const zoneProgress = zoneRange === 0 ? 1 : (clampedValue - target) / zoneRange;
        rotation = 30 + (Math.min(zoneProgress, 1) * 60);
    }

    return (
        <div style={{width: '250px', margin: '0 auto', textAlign: 'center', height: '160px', position: 'relative'}}>
            <svg viewBox="0 0 200 110" style={{width: '100%', height: 'auto'}}>
                <path d="M 20 100 A 80 80 0 0 1 60 30.7" fill="none" stroke="#ef4444" strokeWidth="25" />
                <path d="M 60 30.7 A 80 80 0 0 1 140 30.7" fill="none" stroke="#f59e0b" strokeWidth="25" />
                <path d="M 140 30.7 A 80 80 0 0 1 180 100" fill="none" stroke="#10b981" strokeWidth="25" />
                <g transform={`rotate(${rotation}, 100, 100)`}>
                    <path d="M 100 100 L 100 20" stroke="#334155" strokeWidth="4" strokeLinecap="round" />
                    <circle cx="100" cy="100" r="6" fill="#334155" />
                </g>
            </svg>
            <div style={{position: 'absolute', bottom: '0', width: '100%', textAlign: 'center'}}>
                <div style={{fontWeight: '800', fontSize: '28px', color: textColor, lineHeight: '1'}}>
                    {value} <span style={{fontSize:'14px', color:'#94a3b8', fontWeight:'normal'}}>/ {target}</span>
                </div>
                <div style={{fontSize: '12px', color: '#64748b', fontWeight:'600', textTransform:'uppercase', marginTop:'5px'}}>{label}</div>
            </div>
        </div>
    );
};

export default Speedometer;